import {generationDef} from './generationDef'
import {basic} from 'basic'
import {tree} from '../genealogy'
import Person from 'person/person'
import mariage from 'mariage/mariage'
import React,{useContext} from 'react'
import Mariage from 'mariage/mariage'
import {minYear} from '../tree/treeProvider'
import css from './generation.module.css'
import {wrMsg} from 'utile'
import {Langue} from 'context'
import Text from 'text/text'

const PastGen=React.memo(Generation)

function Generation(props:generationDef.props)
{
    const [className,style]=basic.getBasic(props)
   

    const minimumYear=useContext(minYear)
    const langue=useContext(Langue)
    const {generation}=props
    const {man,woman,date,city,province}=generation

    function mariageLoseFocus()
    {
        // if(!props.develop)
        //     return
        // const {man,woman}=props.generation
        // if(man.firstName.trim().length==0 || woman.firstName.trim().length==0)
        // {
        //     props.onLoseFocus({...props.generation,voirPastGen:false})
        //     return
        // }
        // if(year<=minimumYear)
        // {
        //     props.onLoseFocus({...props.generation,voirPastGen:false,maternel:null,paternel:null})
        //     return
        // }
        // let {generation}=props
        // let {maternel,paternel}=generation
        // if(!maternel)
        //     maternel=tree.emptyFam({paternel:null,maternel:null})
        // if(!paternel)
        //     paternel=tree.emptyFam({paternel:null,maternel:null})
        props.onLoseFocus()

    }

   

    const {paternel,maternel}=props.generation
  
    const nextGen=props.numGen+1

    return <>
                <div className={`${className} generation`} style={{...style}} >
                    <div>
                        <span className={`${css.genTitre} gtitre`}>
                            {
                                props.voirNumGen?"Generation "+props.numGen+" ":null
                            }
                        </span>
                        {props.text}
                        
                    </div>
                    <Text fr={["Monsieur"]} en={["Mr"]}/>
                    <Person value={props.generation.man} 
                            onLoseFocus={props.onLoseFocus}
                            onChange={function(v:{name:string,firstName:string})
                            {
                            const {name,firstName}=v
                            props.onGenChange({...generation,man:{...man,name,firstName}})
                            }}/>
                    <Text fr={["Madame"]} en={["Mrs"]}/>
                    <Person value={props.generation.woman} 
                            onLoseFocus={props.onLoseFocus}
                            onChange={function(v:{name:string,firstName:string})
                            {
                            const {name,firstName}=v
                            props.onGenChange({...generation,woman:{...woman,name,firstName}})
                            }}/>
                    <Mariage value={{city,province,date}}
                            onLoseFocus={mariageLoseFocus}
                            erreur={null}
                            onGenChange={function(v:{city:string,province:string,date:string})
                            {
                                const {city,province,date}=v
                                props.onGenChange({...generation,city,date,province})
                            }}/>
                </div>
                {props.develop?<>
                
                    <>
                        {
                            paternel?
                            <PastGen generation={paternel}
                                    onGenChange={function(gen:tree.FamilyGen){
                                        props.onGenChange({...generation,paternel:gen})
                                    }}
                                    onLoseFocus={props.onLoseFocus}
                                    numGen={nextGen}
                                    voirNumGen={true}
                                    text={wrMsg("Parents de ","Parents of ",langue)+man.firstName+" "+man.name}
                                    develop={true}/>:null
                        }
                    </>
                    <>
                        {
                            maternel?
                            <PastGen generation={maternel}
                                    onGenChange={function(gen:tree.FamilyGen){
                                        props.onGenChange({...generation,maternel:gen})
                                    }}
                                    numGen={nextGen}
                                    voirNumGen={true}
                                    onLoseFocus={props.onLoseFocus}
                                    text={wrMsg("Parents de ","Parents of ",langue)+woman.firstName+" "+woman.name}
                                    develop={true}/>:null
                        }
                    </>
               
                </>:null }
           </>
}

export default React.memo(Generation)

